import { ModuleSetting } from './../../registeration/ModuleSetting/moduleSetting.service';
import { StockModuleSettingsParms } from './../../shared/search-params';
import { Location, CommonModule } from '@angular/common';
import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Pipe, Input, ElementRef, NgModule } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
//shared libs
import { ModalService, SelectizeComponent, AppCodes, StepperComponent, ToastService } from '../../blocks';
import { UserSessionService, StockParms, SharedDateService, SharedModule } from '../../shared';
//services
import { TransferStoreTrans, GenStockTransService, StockTransDetail, StockTransMaster, directAddObj } from '../stock-transaction-interface/gen-stock-transaction.service';
import { TranslateService } from '@ngx-translate/core';
import { StockHelper } from '../../stock-trans-exchange-outpatient/stock-trans-exchange-outpatient-help/stock-outpatient.helper';
import { BlocksModule } from '../../blocks/blocks.module';
import { ItemDataPipeModule } from '../../stock-trans-exchange-outpatient/item-data-filter.pipe';

@Component({
  selector: 'dirct-add-from-supplyorder-or-requestneed',
  templateUrl: './dirct-add-from-supplyorder-or-requestneed.component.html',
  providers: [StockHelper]
})
//=========================================================================/////

export class DirectAddFromSupplyOrderOrRequstNeedComponent implements OnInit, AfterViewInit, OnDestroy {
  // initEvintmitter$() {
  //   this._dateService.saveSub = this._dateService.saveClickEvent.subscribe(res => {
  //     console.log('hello from another save');
  //   })
  // }

  @Input() examminationFlag: any;
  @Input() ExamminationSupplyObj: any;
  @ViewChild('itemMainData') itemMainData: SelectizeComponent;////////////-------------------------------------
  @ViewChild('ItemsAndForms', { static: true }) ItemsAndForms: SelectizeComponent;////////////-------------------------------------
  @ViewChild('storeByUser', { static: true }) storeByUser: SelectizeComponent;////////////-------------------------------------
  @ViewChild('btnCtrl1') btnCtrl1: any;////////////-------------------------------------
  @ViewChild('percentOrValueSelectize') percentOrValueSelectize: SelectizeComponent;
  @ViewChild('discountTypeSelectize') discountTypeSelectize: SelectizeComponent;
  @Input() stepperComponent: StepperComponent;
  @Input() addFromDirectExam: number;
  @Input() addGoods: number;
  @Input() bloodBank: number;
  @Input() mode: any;////////////-------------------------------------
  @ViewChild('barcodeItem') barcodeItem: ElementRef;
  @ViewChild('customCodeItem') customCodeItem: ElementRef;

  objArray: any;
  moduleId: any;
  private unsubscribe = new Subject();
  stockSettingsParms: StockModuleSettingsParms = {};
  stockModuleSettings: {};
  editDirectAddTrans: TransferStoreTrans = <TransferStoreTrans>{};
  editStockTransDetail: StockTransDetail = <StockTransDetail>{};
  DirectAddTransForm: UntypedFormGroup;////////////-------------------------------------
  private ngUnsubscribe: Subject<void> = new Subject<void>();////////////-------------------------------------
  items = [];////////////-------------------------------------
  activeIndex: number;////////////-------------------------------------
  currentStepObj: AppCodes = <AppCodes>{};////////////-------------------------------------
  step1Visited: boolean = true;////////////-------------------------------------
  step2Visited: boolean = false;////////////-------------------------------------
  itemUnits = [];////////////-------------------------------------
  stockTransDet = [];////////////-------------------------------------
  _StockParms = <StockParms>{};////////////-------------------------------------
  tempo = [];////////////-------------------------------------
  unitCode: number;////////////-------------------------------------
  sumOfItemCost: any;////////////-------------------------------------
  sumOfItemSall: any;////////////-------------------------------------
  expiry: any;////////////-----------------expiry of items--------------------
  calCulateStatus: number;////////////-------------calCulateStatus------------------------
  calCulateStatus1: number;////////////------------calCulateStatus-------------------------
  calCulateStatus2: number;////////////------------calCulateStatus-------------------------
  hidden: number = 1;////////////----------------hiiden value---------------------
  showItemsSerach: number = 0;
  linkId: number;
  UpdateItemPricePer: number;
  updateItemCostPrice: number;
  showSave: number = 1;
  amount: number;
  type: number;
  disableNumberInput: boolean;
  modeType: number;
  modeTypeToThisLink: number;
  placHolder: string;
  isItemBonusInCost: number;
  showDiscount: boolean = false;
  discountType: number = 1;
  pvCode: number;
  discountVal: number;
  percentOrValue: number;
  defaultDiscountAttribute: number;
  ValidationAddPatch: number;
  menuActions = [];
  DirectAddTransData = <any>{};
  returnSave: boolean = false;
  showNumber: boolean = false;
  poordersupplycode: number;
  examminatioCode: number;
  editSerial: number;
  roundFinancialFigures: number = this._userSessionService.globalmodulesSettings.RoundFinancialFigures;

  mycustomclick(formdata, items, itemsunit, link) {
    console.log(formdata, items, itemsunit, link);
    this.linkId = link;
    this.items = items;
    this.itemUnits = itemsunit;
    this.DirectAddTransData = formdata;
    this.DirectAddTransInit();;
    this.DirectAddTransForm.patchValue(formdata);
    this.getNetOfPiceitemAndTotalSale(this.items);
    this.save();
    console.log('print hello world!');
  }
  constructor(
    private _DirectAddTransService: GenStockTransService,
    private _toastService: ToastService,
    private _modalService: ModalService,
    private _userSessionService: UserSessionService,
    private _dateService: SharedDateService,
    private _fb: UntypedFormBuilder,
    public translate?: TranslateService,
    private _route?: ActivatedRoute,
    public _StockHelper?: StockHelper,
    private _location?: Location) {
    if (_route && _route.params)
      _route.params.pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(val => {
          if (this._userSessionService.getSessionKey<any>('link')) {
            let link = this._userSessionService.getSessionKey('link');
            this.linkId = link['code'];
            this.mode = link['mode'];
            this.itemUnits = [];////////////-------------------------------------
            this.stockTransDet = [];////////////-------------------------------------
            this._StockParms = <StockParms>{};////////////-------------------------------------
            this.tempo = [];////////////-------------------------------------
            this.items = [];////////////-------------------------------------
            this.itemUnits = [];////////////-------------------------------------
            if (this.itemMainData) {
              this.itemMainData.clear();
              this.itemMainData.clearItems();
            }
            if (this.storeByUser) {
              this.storeByUser.clear();
              this.storeByUser.clearItems();
              // 9892 / 9893 اضافه بضاعه امانه
              if (this.linkId == 9892 || this.linkId == 9893) {
                this.storeByUser.setFastSearchObjDynamicKey("Ma5zan2Manat", 3)
              }

            }
          }
        });
  }
  ngOnInit() {
    this.getModuleSettings();
    let modeTypeArr = this._route.snapshot.params['mode'];
    this.modeType = +modeTypeArr[0];
    this.menuActions.push(403)
    if (this.modeType != 4) {
      this.menuActions.push(2157)
    }
    this.menuActions.push(2158)

    if (this.modeType == 5) {
      this.placHolder = 'THECAFETERIA';
    }
    if (this.modeType == 1) {
      this.placHolder = 'Pharmacy'
    }
    if (this.modeType == 2 || this.modeType == 3) {
      this.placHolder = 'STORE'
    }
    if (this.modeType == 4) {
      this.placHolder = 'BLOODBANK_STORE';
    }
    this.items = [];
    this.DirectAddTransInit();
    let test = [];
    test = this._userSessionService.getSessionKey<any>('IteminexaminationSupply');
    if (test && test.length == 0 || test == null) {
      this.items = [];
    }
    if (test && test.length > 0) this.linkId = 55555555;
    if (this.modeType != 3) {
      this.ExamminationSupplyObj = this._userSessionService.getSessionKey<any>('ExamminationSupplyObj')
      if (this.ExamminationSupplyObj) {
        this.DirectAddTransForm.patchValue(this.ExamminationSupplyObj)///to patch value of exammination suplly
        this.DirectAddTransForm.get('supplierCode').setValue(this.ExamminationSupplyObj['supSupplierCode']);
        this.poordersupplycode = this.ExamminationSupplyObj['poOrderSupplierCode']
        this.examminatioCode = this.ExamminationSupplyObj['serial']
      }
      this.items = this._userSessionService.getSessionKey<any>('IteminexaminationSupply');
      console.log(this.items)
      if (this.items && this.items.length > 0) {
        this.tempo = [];
        for (var i = 0; i < this.items.length; i++) {
          var prem: StockParms = {
            itemCode: this.items[i].code
          }
          this.tempo.push(prem);
        }
        this.getNetOfPiceitemAndTotalSale(this.items)
        if (this.tempo.length > 0)
          this.itemsLoadFunction(this.tempo);
      }
      else if (this.items && this.items.length == 0) {
        this.items = [];
        this.itemUnits = [];
      }
    }

    this._StockHelper.chekIfDurgsOrConsumbales(this.storeByUser, this.itemMainData, 'Type')
    if (this.linkId == 9892 || this.linkId == 9893) {
      this.storeByUser.setFastSearchObjDynamicKey("Ma5zan2Manat", 3)
    }
    this.activeIndex = 1012;
    this._userSessionService.subscribeToKey$('SecLoginPrivileges')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          if (keys.value[0]['updateItemPrice'] == 1) {
            this.UpdateItemPricePer = 1;
          }
          else if (keys.value[0]['updateItemPrice'] != 1) {
            this.UpdateItemPricePer = 0;
          }

          if (keys.value[0]['updateItemCostPrice'] == 1) {
            this.updateItemCostPrice = 1;
          }
          else if (keys.value[0]['updateItemCostPrice'] != 1) {
            this.updateItemCostPrice = 0;
          }
        }
      });
    this.getOriginalNumber();
  }
  getOriginalNumber() {
    this.items.forEach((row, index) => {
      row.originalNumber = row.number;
    });
  }
  ngAfterViewInit() {
    this._userSessionService.setBtnCtrl(this.btnCtrl1);
    this.DirectAddTransForm.get('discountInclusion').setValue(this.defaultDiscountAttribute);
  }
  //===============================================Gouhar==============================/////

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this._StockHelper.ngOnDestroy();
  }
  getNetOfPiceitemAndTotalSale(items) {
    let sum: number = 0;
    let formTotalCost: number = 0
    let formTotalTax: number = 0
    items.forEach((row) => {
      row['netOfPiceitem'] = row['unitSale'] * row['number']
      sum = sum + row['netOfPiceitem']
      row['netOfPiceUnits'] = row['unitCost'] * row['number']
      formTotalCost = formTotalCost + row['netOfPiceUnits']
      formTotalTax += row['itemtaxMoney']
    });
    this.DirectAddTransForm.get('totalSale').setValue(sum)
    this.DirectAddTransForm.get('totalCost').setValue(formTotalCost)
    if (!this.DirectAddTransForm.get('totalNetCost').value) {
      this.DirectAddTransForm.get('totalNetCost').setValue(formTotalCost)
    }
    this.DirectAddTransForm.get('grossTotalCost').setValue(formTotalCost)
    this.DirectAddTransForm.get('poTotalTaxMoney').setValue(formTotalTax)
  }


  // initialize DirectAddTrans form
  DirectAddTransInit() {
    let date = this._dateService.convertFromDateToNgBsObject(new Date());
    this.DirectAddTransForm = this._fb.group({
      tranSerial: new UntypedFormControl(),
      storeCode: new UntypedFormControl('', Validators.required),
      transType: new UntypedFormControl(),
      totalCost: new UntypedFormControl(),
      totalSale: new UntypedFormControl(),
      handNumber: new UntypedFormControl(),
      notes: new UntypedFormControl(),
      supplierCode: new UntypedFormControl('', Validators.required),
      billNo: new UntypedFormControl(),
      transDate: date,
      transCode: new UntypedFormControl(),
      discount: new UntypedFormControl(),
      discountType: new UntypedFormControl(),
      masterAdditionalDiscountOutTax: new UntypedFormControl(),
      masterAdditionalDiscountType: new UntypedFormControl(),
      totalNetCost: new UntypedFormControl(),
      grossTotalCost: new UntypedFormControl(),
      discountInclusion: new UntypedFormControl(2, Validators.required),
      customCodeItem: new UntypedFormControl()
      , barcodeItem: new UntypedFormControl()
      , poTotalTaxMoney: new UntypedFormControl()
    })
  }


  onClicked(e: number): void {
    switch (e) {
      case 1:
      case -1000://save
        this.save();
        break;
      case 6839://Suspension
        this.savesuspensionTransaction();
        break;
      case 6907://DeleteSuspension
        this.deleteSuspensionTransaction();
        break;
      case 2:
        this._goBack();
        break;
      default:
        this.cancel();
    }
  }

  savesuspensionTransaction() {
    this._DirectAddTransService.addStockTransactionSuspension(this.suspensionTransaction()).pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        if (c && c.data && c.data.length > 0) {
          console.log(c.data);
        }
      },
        error => console.log(error),
        () => {
          this.items = [];
          if (this.ItemsAndForms) {
            this.ItemsAndForms.clear();
            this.ItemsAndForms.clearItems();
          }
        }
      );
  }

  suspensionTransaction() {
    //master
    let stockTransMaster = <StockTransMaster>{};
    stockTransMaster = this.DirectAddTransForm.value;
    let form: directAddObj = <directAddObj>{
      serial: this.editSerial || -1,
      dataStatus: 1,
      examinaionCode: this.examminatioCode,
      poOrderCode: this.poordersupplycode,
      transType: 2,
      jsonMaster: JSON.stringify(stockTransMaster),
      jsonDetails: JSON.stringify(this.items),
      jsonMasteritemUnits: JSON.stringify(this.itemUnits),
      stocktype: this.modeType,
    };
    this.editSerial > 0 ? form.dataStatus = 2 : form.dataStatus = 1;
    return form;
  }
  deleteSuspensionTransaction() {
    let msgAr = 'هل تريد حذف الحركه المعلقة رقم ' + '' + this.editSerial + '' + 'المورد رقم ' + '' + this.DirectAddTransForm.get('supplierCode').value;
    this._modalService.activeMes(msgAr).then(responseOK => {
      if (responseOK) {
        let deleteSuspensionTransactionObject: directAddObj = <directAddObj>{
          serial: this.editSerial,
          dataStatus: 3
        };
        this._DirectAddTransService.addStockTransactionSuspension(deleteSuspensionTransactionObject).pipe(
          takeUntil(this.ngUnsubscribe))
          .subscribe(c => {
          },
            error => console.log(error),
            () => {
              this.items = [];
              this.DirectAddTransForm.reset();
              this._StockHelper.resetSelectize(this.ItemsAndForms);
            }
          );
      }
    })
  }
  showSuspensionBtn: number;

  addItemsAndForms(event) {
    if (event) {
      this.items = [];
      this.itemUnits = [];
      this.editSerial = event.code;
      this.items = JSON.parse(event.jsonDetails);
      this.itemUnits = JSON.parse(event.jsonMasteritemUnits)
      this.DirectAddTransForm.patchValue(JSON.parse(event.jsonMaster));
      this.DirectAddTransForm.get('transCode').setValue('');
    }
    if (this.items.length > 0) {
      this.showSuspensionBtn = 1
    } else {
      this.showSuspensionBtn = 0
    }
  }

  ////////==================================================== gift ================================================////////
  itemUnitsFactorDesc = [];
  itemsLoadFunction(tempo) {    //_______________________used__________
    if (tempo.length > 0) {
      tempo = tempo.filter((v, i, a) => a.indexOf(v) === i);
      this._DirectAddTransService.itemsLoad(tempo)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {
          if (c && c.data && c.data.length > 0) {
            this.itemUnits = c.data;
          }
          if (this.itemUnits.length > 0) {
            this.isItemBonusInCost = +this.itemUnits[this.itemUnits.length - 1]['isItemBonusInCost'];
          }
          if (c && c.data2 && c.data2.length > 0) {
            this.itemUnitsFactorDesc = c.data2;
          }
        },
          error => console.log(error),
          () => {
            if (this.itemUnits && this.itemUnits.length > 0) {
              for (var i = 0; i < this.items.length; i++) {
                let unitValue = this._StockHelper.getUnitValueByItems(this.itemUnits, this.items[i]['code']);
                if (unitValue && unitValue.length > 0) {
                  var maxFactor = 0
                  for (let index = 0; index < unitValue.length; index++) { // to get large factor
                    var element = unitValue[index]['factor'];
                    if (element && element >= maxFactor) {
                      maxFactor = element
                    }
                  }
                }
                this.items[i].taxType = 2;
                this.items[i].discountType = 2;
                this.items[i].additionalDiscountType = 2;
                // i am sad  
                this.calCulateStatus = 2;
                this.calCulateStatus1 = 2;
                this.calCulateStatus2 = 2;
                if (this.defaultDiscountAttribute == 1)
                  this.items[i].tax = 0;
              }
            }
            console.log(this.items[i])
          });
    }
  }
  // value changed

  getFactorDesc(itemCode) {
    if (this.itemUnitsFactorDesc && this.itemUnitsFactorDesc.length > 0) {
      let desc = this.itemUnitsFactorDesc.find(x => x.itemCode == itemCode)
      if (desc && desc['itemUnitFactor'])
        return desc['itemUnitFactor'];
    }
  }

  save() {
    this.items.forEach(el => {
      el.errorselected = 0
    });
    this.returnSave = false;
    for (var i = 0; i < this.items.length; i++) {
      if (+this.sumOfItemCost > +this.sumOfItemSall) {
        this._toastService.activateMsg('UI2020');
        this.returnSave = true;
        this.items[i]['errorselected'] = 1
      }
      //لو بيانات ناقصه
      if (this.items[i].expiry == true) {
        if (this.items[i].expirationDate == undefined || this.items[i].expirationDate == null || this.items[i].expirationDate == "") {
          this.items.forEach(el => {
            if (el.expirationDate == undefined || el.expirationDate == null || el.expirationDate == "") {
              this._toastService.activateMsg('WARNINGEXPIRATIONDATE', el.customCode);
              el.errorselected = 1
            }
          });
          this.returnSave = true;
        }
        if (this.items[i].expirationDate < this._dateService.convertFromDateToNgBsObject(new Date())) {
          this.items.forEach(el => {
            if (el.expirationDate < this._dateService.convertFromDateToNgBsObject(new Date())) {
              this._toastService.activateMsg('UI1212', el.customCode);
              el.errorselected = 1
            }
          });
          this.returnSave = true;
        }
        let date = new Date(); //-----تاريخ الصلاحيه
        let _vDate = this._dateService.convertFromNgBsToDate(this.items[i].expirationDate)
        if (_vDate < date) {
          this._toastService.activateMsg("UI1212", this.items[i]['customCode'])
          this.returnSave = true;
          this.items[i]['errorselected'] = 1
        }
      }
      if (+this.items[i].unitCost > +this.items[i].unitSale) {
        this.items.forEach(el => {
          if (+el.unitCost > +el.unitSale) {
            this._toastService.activateMsg('UI2020', el.customCode);
            el.errorselected = 1
          }
        });
        this.returnSave = true;
      }
      if (this.ValidationAddPatch == 1) {//ادخال الباتش
        if (this.items[i]['patchCode'] == (undefined || null) || this.items[i]['patchCode'] == "") {
          this.items.forEach(el => {
            if (el.patchCode == (undefined || null) || el.patchCode == "") {
              this._toastService.activateMsg('UI288', el.customCode);
              el.errorselected = 1
            }
          });
          this.returnSave = true;
        }
      }
    }
    if (this.returnSave == true) {
      return false;
    }
    this.showSave = 0;
    let oenBalanceOfItem = this._DirectAddTransService.checkItemsToSave(this.DirectAddTransForm, this.items, this.itemUnits, this.linkId, this.editSerial);
    // oenBalanceOfItem.stockTransDetail.forEach(element => { -- abdo 8/11/2024 shoud save it
    //   element.itemtaxMoney = 0;
    // });
    this._DirectAddTransService.transfereTtemFromStore(oenBalanceOfItem)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        this.showSave = 1;
        if (c['returnFlag']) {
          this.items = [];
          this.itemUnits = [];
          if (c.data1[0].totalCost != undefined || c.data1[0].totalCost != null) {
            this.DirectAddTransForm.get('totalCost').setValue(c.data1[0].totalCost);
          }
          else if (c.data2[0].totalCostBeforDiscount) {
            this.DirectAddTransForm.get('totalCost').setValue(c.data2[0].totalCostBeforDiscount);
          }

          if (c && c.data3[0].transCode) {
            this.DirectAddTransForm.get('transCode').setValue(c.data3[0].transCode);
          }
          if (c.data[0].tranSerial) {
            this._userSessionService.setSessionKey("AllowResetOpenBalace", 1);
            this.DirectAddTransForm.get('tranSerial').setValue(c.data[0].tranSerial);
            this._userSessionService.setSessionKey('directAddFalg', 1)

            this._userSessionService.setSessionKey("TRANSSERIAL", c.data[0]);
            if (this.stepperComponent) {
              this.stepperComponent.gotoStepOfAppcode(1013);
            }

          }
          this._StockHelper.resetForm(this.DirectAddTransForm);
        }

      },
        error => console.log(error),
        () => {
          this.showSave = 1;
          if (this.ItemsAndForms) {
            this.ItemsAndForms.clear();
            this.ItemsAndForms.clearItems();
          }
        })
  }


  cancel(showToast = true) {
    this._goBack();
  }

  //#endregion 

  //#region helpers
  isAddMode() {
    let id = +this._route.snapshot.params['id'];
    return isNaN(id) || id == null;
  }

  _goBack(): void {
    this._location.back();
  }

  antherPatch(row) {
    if (row) {
      //this.showNumber = true
      var temp = Object.assign({}, row)
      temp["patch"] = 1
      temp["gift"] == 0
      temp["expiryDate"] = ""
      temp["number"] = ""
      temp["expirationDate"] = ""
      temp["originalNumber"] = row.originalNumber
      temp["showNumber"] = true
      temp["newPatchCode"] = row.code + '001'
      this.items.push(temp)
    }
  }
  numberCheck(numberChanged: number, row: any) {
    if (row.showNumber = true) {
      let x = 0
      let y = 0
      this.items.forEach((el, index) => {
        if (el.code == row.code && row.patch == 1 && el.patch == row.patch && el.originalNumber == row.originalNumber) {
          x += +el.number;
          console.log(x);
        }
      });
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].code == row.code && this.items[i].patch != 1 && row.patch == 1) {
          if (numberChanged == row.number) {
            this.items[i].number = row.originalNumber - x;
            this.items[i].number < 0 ? this.items[i].number = 0 : this.items[i].number;
            if (x > row.originalNumber) {
              row.number = 0;
              this.items[i].number = row.originalNumber;
            }
            if (this.items[i].number != null || this.items[i].number != undefined) {
              this.items[i].totCostAfterDis = this.items[i].unitCost * this.items[i].number;
              this.items[i].totCostAfterDis = +this.items[i].totCostAfterDis;
              this.items[i].netOfPiceitem = this.items[i].unitSale * this.items[i].number;
              this.items[i].netOfPiceitem = +this.items[i].netOfPiceitem;
              this.items[i].netOfPiceUnits = +this.items[i].totCostAfterDis;
            }
          }
        }
      }
    }
  }
  // /// to delete item from array 
  deletItem(row) {
    let ind = this.items.indexOf(row);
    this.items.splice(ind, 1);
    ///// عشان اعمل refresh hg total لو مسحت صنف
    if (row && row["patch"] == 1) {
      row.number = 0;
      this.onNuberChange(event, row);
    } else {
      this.onNuberChange(event, row);
    }
  }
  onUnitChange(event, row) {
    let unitCode = event.target.value;
    if (unitCode == "") {
      return false;
    }
    if (row) {
      let unitCode = event.target.value;
      this.unitCode = unitCode
      let unitValue = this._StockHelper.getUnitValue(this.itemUnits, unitCode, row['code']);
      if (unitValue) {
        if (row['gift'] == 1 && this.isItemBonusInCost == 2) {
          row['unitCost'] = 0;
        } else {
          row['unitCost'] = unitValue[0]["purchasePrice"]; // ده سعر الوحده
        }
        row['unitSale'] = unitValue[0]["salePrice"];
      }
      this._StockHelper._validateUnitCostAndSale(row);

      if (row['number'] != null || row['number'] != undefined) {

        row['totCostAfterDis'] = row['unitCost'] * row['number'];
        row['totCostAfterDis'] = +row['totCostAfterDis'];
        row['netOfPiceUnits'] = +row['totCostAfterDis'];

        row['netOfPiceitem'] = row['unitSale'] * row['number'];
        row['netOfPiceitem'] = +row['netOfPiceitem'];


      }
      this.onNuberChange(event, row);
    }
  }
  onNuberChange(event, row) {

    //عشان لو مفيش ولا روو يخلى ال توتل ب صفر
    if (this.items.length == 0) {
      this.DirectAddTransForm.get('totalSale').setValue(0);
      this.DirectAddTransForm.get('totalCost').setValue(0);
      this.DirectAddTransForm.get('totalNetCost').setValue(0);
      this.DirectAddTransForm.get('grossTotalCost').setValue(0);
      this.DirectAddTransForm.get('totalTaxes').setValue(0);//abdo
    }
    if (row && row["patch"] == 1) {
      this._StockHelper._validateUnitCostAndSale(row);
      if (row['unitCost'] > row['unitSale']) {
        this._toastService.activateMsg('UI2020');
        return;
      }
      this.numberCheck(row['number'], row)

      if (row['number'] != null || row['number'] != undefined) {

        row['totCostAfterDis'] = row['unitCost'] * row['number'];
        row['totCostAfterDis'] = +row['totCostAfterDis'];
        row['netOfPiceUnits'] = +row['totCostAfterDis'];

        row['netOfPiceitem'] = row['unitSale'] * row['number'];
        row['netOfPiceitem'] = +row['netOfPiceitem'];
      }

    }

    if (+row['unitCost'] > +row['unitSale']) {
      this._toastService.activateMsg('UI2020');
    }
    //////====================================================validation =========================
    if (this.defaultDiscountAttribute == 1) {
      if (row['number'] != (null || undefined)) {

        if (row['gift'] == 1 && this.isItemBonusInCost == 2) {
          row['totCostAfterDis'] = 0;
          row['netOfPiceUnits'] = 0;
        } else {
          row['totCostAfterDis'] = row['unitSale'] * row['number'];
          if (row['totCostAfterDis']) {
            row['totCostAfterDis'] = +row['totCostAfterDis'].toFixed(this.roundFinancialFigures);
          }
          row['netOfPiceUnits'] = row['unitSale'] * row['number'];
          if (row['netOfPiceUnits']) {
            row['netOfPiceUnits'] = +row['netOfPiceUnits'].toFixed(this.roundFinancialFigures);
          }
        }
        row['netOfPiceitem'] = row['unitSale'] * row['number'];
        row['netOfPiceitem'] = +row['netOfPiceitem'];



        if (row['number'] != null || row['number'] != undefined) {
          this._StockHelper.calSumItemCostAndSAle(this.items, this.DirectAddTransForm)
        }


      }
    }
    else {
      if (row['number'] != (null || undefined)) {

        row['totCostAfterDis'] = row['unitCost'] * row['number'];
        if (row['totCostAfterDis']) {
          row['totCostAfterDis'] = +row['totCostAfterDis'].toFixed(this.roundFinancialFigures);
        }


        row['netOfPiceitem'] = row['unitSale'] * row['number'];
        row['netOfPiceitem'] = +row['netOfPiceitem'];


        row['netOfPiceUnits'] = row['unitCost'] * row['number'];
        if (row['netOfPiceUnits']) {
          row['netOfPiceUnits'] = +row['netOfPiceUnits'].toFixed(this.roundFinancialFigures);
        }

        if (row['number'] != null || row['number'] != undefined) {
          this._StockHelper.calSumItemCostAndSAle(this.items, this.DirectAddTransForm)
        }

      }
    }
    this.calculatTotals();
  }


  calculatTotals() {
    if (this.items == null || this.items == undefined)
      return;

    let grossSum = 0;
    let netOfPiceUnitsSum = 0;
    let totalGiftCost = 0;

    let grossSumTa = 0;
    let grossSumTax = 0;
    if (this.defaultDiscountAttribute == 1) {
      for (var i = 0; i < this.items.length; i++) {
        netOfPiceUnitsSum += +(this.items[i].netOfPiceUnits);

        if (this.items[i].number != undefined || this.items[i].number != null) {
          grossSum += +(this.items[i].number) * +(this.items[i].unitSale);
          grossSumTa = +(this.items[i].number) * +(this.items[i].unitSale);//abdo
          if (this.items[i].gift != undefined && this.items[i].gift == 1) {
            if (this.isItemBonusInCost == 2) {
              totalGiftCost += 0;
            } else {
              totalGiftCost += +(this.items[i].number) * +(this.items[i].unitSale);
            }
          }
        }
        if (this.items[i].taxType && this.items[i].tax) {
          if (+this.items[i].taxType == 1) {
            grossSum += +(this.items[i].tax);
            grossSumTax += +(this.items[i].tax);
            this.DirectAddTransForm.get('totalTaxes').setValue(grossSumTax);//abdo
          }
          if (+this.items[i].taxType == 2) {
            grossSum += +(this.items[i].tax) * grossSum / 100;
            grossSumTax += +(this.items[i].tax) * grossSumTa / 100;
            this.DirectAddTransForm.get('totalTaxes').setValue(grossSumTax);//abdo 
          }
        }
        if (this.items[i].tax == 0) {
          this.DirectAddTransForm.get('totalTaxes').setValue(0);//abdo
        }
      }
      this.DirectAddTransForm.get('grossTotalCost').setValue(netOfPiceUnitsSum - totalGiftCost);
      this.DirectAddTransForm.get('totalCost').setValue(netOfPiceUnitsSum);
    }
    else {
      for (var i = 0; i < this.items.length; i++) {
        netOfPiceUnitsSum += +(this.items[i].netOfPiceUnits);
        if (this.items[i].number != undefined || this.items[i].number != null) {
          grossSum += +(this.items[i].number) * +(this.items[i].unitCost);
          grossSumTa = +(this.items[i].number) * +(this.items[i].unitCost);;//abdo

          if (this.items[i].gift != undefined && this.items[i].gift == 1) {
            totalGiftCost += +(this.items[i].number) * +(this.items[i].unitCost);
          }
        }
        if (this.items[i].taxType && this.items[i].tax) {
          if (+this.items[i].taxType == 1) {
            grossSum += +(this.items[i].tax);
            grossSumTax += +(this.items[i].tax);
            this.DirectAddTransForm.get('totalTaxes').setValue(grossSumTax);//abdo
          }
          if (+this.items[i].taxType == 2) {
            grossSum += +(this.items[i].tax) * grossSum / 100;
            grossSumTax += +(this.items[i].tax) * grossSumTa / 100;
            this.DirectAddTransForm.get('totalTaxes').setValue(grossSumTax);//abdo
          }
        } if (this.items[i].tax == 0) {
          this.DirectAddTransForm.get('totalTaxes').setValue(0);//abdo
        }
      }
      this.DirectAddTransForm.get('grossTotalCost').setValue(netOfPiceUnitsSum - totalGiftCost);
      this.DirectAddTransForm.get('totalCost').setValue(netOfPiceUnitsSum);
    }
  }
  expirationDateClick(row) {
    this._StockHelper.expirationDateValidationCheck(row);
  }
  rowIconClick(actionCode: number, row) {
    if (actionCode == 403) {
      this.deletItem(row);
    }
    if (actionCode == 2158) {
      this.antherPatch(row);
    }
  }
  getModuleSettings() {
    this._userSessionService.subscribeToKey$('link')
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(link => {
        if (link.name = 'link') {
          this.stockSettingsParms.moduleId = link.value.parentCode;
          this._userSessionService.subscribeToKey$('modulesSettings')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
              if (keys.value) {
                this.stockModuleSettings = keys.value[`m_${this.stockSettingsParms.moduleId}`];
                this.defaultDiscountAttribute = this.stockModuleSettings['DefaultDiscountAttribute'];
                this.ValidationAddPatch = this.stockModuleSettings['EnterPatch'];
              }
            });
          if (!this.stockModuleSettings || !this.defaultDiscountAttribute || !this.ValidationAddPatch) {
            this._DirectAddTransService.getStockModuleSettings(this.stockSettingsParms)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(c => {
                if (c.data && c.data.length > 0) {
                  this.stockModuleSettings = c.data[0];
                  if (this.stockModuleSettings) {
                    this.defaultDiscountAttribute = this.stockModuleSettings['defaultDiscountAttribute'];
                    this.DirectAddTransForm.get('discountInclusion').setValue(this.defaultDiscountAttribute);
                    this.ValidationAddPatch = this.stockModuleSettings['enterPatch'];
                  }
                }
              });
          }
        }
      });
  }

}
@NgModule({
  declarations: [DirectAddFromSupplyOrderOrRequstNeedComponent],
  exports: [DirectAddFromSupplyOrderOrRequstNeedComponent],
  imports: [CommonModule, BlocksModule, SharedModule, ItemDataPipeModule]
})
export class DirectAddFromSupplyOrderOrRequstNeedModule { }